import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";
import { SovosAIIcon } from "mosaic-react-platform";

const ColumnMappingAiLoadingBanner = ({
    i18n = (strings) => (Array.isArray(strings) ? strings.join("") : strings),
}) => (
    <SovosBox
        sx={{
            alignItems: "center",
            bgcolor: "#FFF8E1",
            border: "1px solid #FFE082",
            borderRadius: 1,
            display: "flex",
            gap: 1.5,
            justifyContent: "space-between",
            mb: 2,
            px: 2,
            py: 1.5,
        }}
    >
        <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1.5, minWidth: 0 }}>
            <SovosBox sx={{ alignItems: "center", display: "flex", "& svg": { height: 24, width: 24 } }}>
                <SovosAIIcon />
            </SovosBox>
            <SovosTypography variant="body2" color="text.primary">
                {i18n`Sovi AI is working on your column mapping. It might take a few minutes...`}
            </SovosTypography>
        </SovosBox>
    </SovosBox>
);

export default ColumnMappingAiLoadingBanner;
